import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
    return (
        <div className="min-h-[60vh] flex items-center justify-center text-center px-6">
            <div className="max-w-lg">
                <h1 className="font-serif text-4xl md:text-5xl leading-tight">No worries.</h1>
                <p className="mt-4 text-muted-foreground">Your free EDEN experience is unchanged. You can return to Premium anytime.</p>
                <Link to="/membership">
                    <Button className="mt-8 bg-[hsl(var(--eden-forest))] text-[hsl(var(--eden-cream))] hover:bg-[hsl(var(--eden-forest))]/90 rounded-md text-xs uppercase tracking-[0.3em] h-11 px-6" data-testid="payment-cancel-return">
                        Return to membership
                    </Button>
                </Link>
            </div>
        </div>
    );
}
